'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');



//////////////////
// WEBPACK FOOTER
// ./~/promise/lib/index.js
// module id = 1161
// module chunks = 17